import { CardFooter, Link } from '@/components'

export const ExistingUserFooter = () => (
  <CardFooter className="flex flex-col space-y-3 pt-2 px-4 sm:px-6">
    <div className="relative w-full">
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-white px-2 text-muted-foreground">
          Existing user
        </span>
      </div>
    </div>

    <div className="text-center text-sm">
      <span className="text-muted-foreground">Already have an account? </span>
      <Link to="/login">Sign in</Link>
    </div>
  </CardFooter>
)
